import { render, staticRenderFns } from "./OffersSelect.vue?vue&type=template&id=a25eefa8&scoped=true"
import script from "./OffersSelect.vue?vue&type=script&lang=js"
export * from "./OffersSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25eefa8",
  null
  
)

export default component.exports